module.exports = __webpack_public_path__ + "static/media/data-min.0501f4d5.webp";